import { xxHashObject } from "@flakiness/shared/common/utils.js";
import { EnvGroup } from "./envGroup.js";
import { Stats } from "./stats.js";
import { TestIndex } from "./testIndex.js";

/** The environments of a {@link TestIndex} that an {@link EnvGroup} accepts. */
export class ResolvedTimeline {
  static create(testIndex: TestIndex, envGroup: EnvGroup) {
    const envs = testIndex.environments();
    const envIdxs: Stats.EnvIndex[] = [];
    for (let envIdx = 0 as Stats.EnvIndex; envIdx < envs.length; ++envIdx) {
      if (envGroup.accepts(envs[envIdx]))
        envIdxs.push(envIdx);
    }
    return new ResolvedTimeline(envGroup, envIdxs);
  }

  private _envs: Set<Stats.EnvIndex>;
  private _etag: string;

  private constructor(public readonly envGroup: EnvGroup, envs: Stats.EnvIndex[]) {
    this._envs = new Set(envs);
    this._etag = xxHashObject({
      envs: envs.toSorted((a, b) => a - b),
      envGroup: envGroup.etag(),
    });
  }

  acceptsEnvironment(envIdx: Stats.EnvIndex) {
    return this._envs.has(envIdx);
  }

  etag() {
    return this._etag;
  }
}
